import { KeyboardKeys } from "@/enums/keyboard-keys.enum";
import store from "@/store";

export default class HandleSuggestionKeyboardEvent {
	static handle(event: KeyboardEvent, suggestionRef: HTMLElement | null): void {
		event.preventDefault();
		const parentEvent = store.getters.getUserKeyboardEvent();
		const parentTarget = parentEvent?.target as HTMLElement;
		const target = event.currentTarget as HTMLElement;
		const nextElement = target?.nextElementSibling as HTMLElement;
		const previousElement = target?.previousElementSibling as HTMLElement;


		switch (event.key as KeyboardKeys) {
		case KeyboardKeys.ENTER:
		    suggestionRef?.click();
			break;
		case KeyboardKeys.ARROW_DOWN:
			suggestionRef?.setAttribute("tabindex", "-1");
			nextElement?.setAttribute("tabindex", "0");
			nextElement.focus();
			break;
		case KeyboardKeys.ARROW_UP: {
			const focusableElement = previousElement || parentTarget;
			suggestionRef?.setAttribute("tabindex", "-1");
			focusableElement.setAttribute("tabindex", "0");
			focusableElement.focus();
			break;
		}
		case KeyboardKeys.ESCAPE:
			suggestionRef?.blur();
			parentTarget?.focus();
			break;
		}
	}
}